import type { ReactNode } from 'react';
import { aud } from '@/utils/format';

/** Format a money amount for the reporting screen, or an em-dash when the viewer
 *  is on the operations (no-money) lens. Reporting gates money to the owner
 *  persona — stricter than the app-wide `aud()` financials mask — so branch here
 *  before formatting. */
export function money(amountAud: number, visible: boolean): string {
  return visible ? aud(amountAud) : '—';
}

export function Money({ amountAud, visible }: { amountAud: number; visible: boolean }) {
  return <span data-testid="reporting-money-value">{money(amountAud, visible)}</span>;
}

/**
 * A reported figure with its raw value on the element (`data-amount`,
 * `data-count`), so a tie-out check reads the number the screen computed rather
 * than parsing formatted text (B10).
 */
export function Figure({
  testId,
  amountAud,
  count,
  children,
}: {
  testId: string;
  amountAud?: number;
  count?: number;
  children: ReactNode;
}) {
  return (
    <span data-testid={testId} data-amount={amountAud} data-count={count}>
      {children}
    </span>
  );
}
